import { render, staticRenderFns } from "./SecurePoll.vue?vue&type=template&id=66077f94&"
import script from "./SecurePoll.vue?vue&type=script&lang=ts&"
export * from "./SecurePoll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports